import React, { useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { Button, ButtonBar } from '../../../../common/components';
import { actions } from '../../redux/customerActions';
import Modal from 'react-bootstrap/lib/Modal';

const ArchiveCustomerButton = ({ id, customerName, onMarkCustomerDeceased }) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const { isSubmitting } = useSelector((state) => state.customer);

  const openConfirmModal = () => {
    setShowConfirmModal(true);
  };
  const closeConfirmModal = () => {
    setShowConfirmModal(false);
  };

  const handleArchive = () => {
    return Promise.resolve(onMarkCustomerDeceased(id)).then(() => {
      setShowConfirmModal(false);
    });
  };

  return (
    <>
      <Modal show={showConfirmModal} onHide={closeConfirmModal}>
        <Modal.Header closeButton>Mark Customer Suppressed</Modal.Header>
        <Modal.Body>
          {`Are you sure you want to mark ${customerName} as Suppressed?`}
        </Modal.Body>
        <Modal.Footer>
          <ButtonBar>
            <Button
              bsStyle={'primary'}
              handleClick={handleArchive}
              className={'pull-right'}
              isLoading={isSubmitting}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Archiving...' : 'Archive'}
            </Button>
            <Button
              bsStyle={'default'}
              handleClick={closeConfirmModal}
              className={'pull-right'}
            >
              Cancel
            </Button>
          </ButtonBar>
        </Modal.Footer>
      </Modal>

      <Button bsStyle={'primary'} className={'pull-right'} handleClick={openConfirmModal}>
        Mark Customer Suppressed
      </Button>
    </>
  );
};

export default connect(
  null,
  {
    onMarkCustomerDeceased: actions.markCustomerDeceased,
  },
)(ArchiveCustomerButton);
